import gql from 'graphql-tag';

export const GetSources = gql `
  query GetSources {
    sources
  }
`;